import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeLegetos';
const args = {};

export class ModeLegetos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
